import { inject, Injectable } from "@angular/core";
import { Router, UrlTree } from "@angular/router";
import { AuthService } from "app/core/auth/service/auth.service";
import { Observable, of } from "rxjs";
import { map, switchMap } from "rxjs/operators";

@Injectable()
export class AuthGuard {
  private authService = inject(AuthService);
  private router = inject(Router);

  /**
   *  Route guard logic for account-selection page
   */
  canActivate(): Observable<boolean | UrlTree> {
    return this.authService.waitForKeycloakReady().pipe(
      switchMap((isAuthenticated) => {
        if (isAuthenticated) {
          return this.authService.permissionsReady$.pipe(
            switchMap(() => this.authService.hasManagementPermissions$),
            map((hasPermission) =>
              hasPermission
                ? true
                : this.router.parseUrl("/insufficient-permissions"),
            ),
          );
        } else {
          this.saveCurrentPath();
          this.authService.login();
          return of(false);
        }
      }),
    );
  }

  canActivateChild(): Observable<boolean | UrlTree> {
    return this.authService.waitForKeycloakReady().pipe(
      switchMap((isAuthenticated) => {
        if (isAuthenticated) {
          return this.authService.permissionsReady$.pipe(
            switchMap(() => this.authService.hasManagementPermissions$),
            map((hasPermission) =>
              hasPermission
                ? true
                : this.router.parseUrl("/insufficient-permissions"),
            ),
          );
        } else {
          this.saveCurrentPath();
          this.authService.login();
          return of(false);
        }
      }),
    );
  }

  private saveCurrentPath(): void {
    const currentPath = window.location.pathname + window.location.search;
    if (currentPath !== "/auth/callback" && currentPath !== "/") {
      sessionStorage.setItem("auth_redirect", currentPath);
    }
  }
}
